import { Api } from "../util/Api";
import { getDB } from "../util/db";

export class Job {
	static async syncJobs(user) {
		try {
			let jobs = await Api.forProfile(user).inspectionCall("/v2/jobs/active");
			let db = await getDB();
			await db.clear("Jobs");
			for(const job of jobs) {
				await db.put("Jobs", job);
			};
			console.log("Jobs syncd");
		} catch(err) {
			console.log("Error syncing jobs")
		}
	}

	async getSharedRecipients(profile) {
		let results = Api.forProfile(profile).inspectionCall(`/v2/jobs/${this.id}/shares`)
		return results;
	}

	async shareWithUser(profile, uid) {
		let results = await Api.forProfile(profile).inspectionCall(`/v2/jobs/${this.id}/shares`, "POST", {
			sharedWithUserIdentifier: uid
		});
		return results;
	}

	async unshareWithUser(profile, uid) {
		let results = await Api.forProfile(profile).inspectionCall(`/v2/jobs/${this.id}/shares/${uid}`, "DELETE");
		return results;
	}

	static hydrate(jobinfo) {
		let job = Object.assign(new Job(), jobinfo);
		return job;
	}

	static async find(jobId) {
		let db = await getDB();
		let job = await db.get("Jobs", jobId);
		return Job.hydrate(job);
	}
	
	static async saveJob(user, job) {
		return await Api.forProfile(user).inspectionCall("/v2/jobs", "POST", job);
	}
	
	static async deleteJob(user, job) {
		await Api.forProfile(user).inspectionCall(`/v2/jobs/${job.id}`, "DELETE");
	}
}